import React from "react";

function IrpFeautures() {
  return (
    <div>
      <p>
        Flexible contributions: Contributions can be fixed or varying; made
        monthly, quarterly, semiannually or annually.
      </p>

      <ul className="list-disc list-inside">
        <li>An employer can contribute an equal or higher amount as an employment incentive.</li>
        <li>The minimum contribution under the policy is Kes 500. There is no upper limit on contributions.</li>
        <li>Britam will provide you with a personalized individual retirement plan account and keep track of your savings and interest earned.</li>
        <li>A personalized statement of savings will be sent to you at the end of each financial year or any other time on request.</li>
        <li>A member can access accumulated fund at any time subject to the prevailing regulations.</li>
      </ul>
    </div>
  );
}

export default IrpFeautures;
